const STAFF_COMPUTED_STATUSES = [
    "UPCOMING",
    "CONSTRUCTION",
    "LIVE",
    "READY_DISMANTLING",
    "DISMANTLING",
    "PAST",
];
const API_DATE_TIME_FORMAT = "YYYY-MM-DD HH:mm:ss";


const hasCompletePeriod = (period) => (
    period?.[ 0 ]?.isValid?.() && period?.[ 1 ]?.isValid?.()
);

const chainWhereConditions = (conditions) => conditions.reduceRight(
    (nextCondition, condition) => (
        nextCondition ? { ...condition, AND: [ nextCondition ] } : condition
    ),
    undefined
);

const addPeriodOverlapConditions = (conditions, period, startColumn, endColumn) => {
    if (!hasCompletePeriod(period))
    {
        return;
    }

    conditions.push(
        {
            column: startColumn,
            operator: "LTE",
            value: period[ 1 ].clone().endOf("day").format(API_DATE_TIME_FORMAT),
        },
        {
            column: endColumn,
            operator: "GTE",
            value: period[ 0 ].clone().startOf("day").format(API_DATE_TIME_FORMAT),
        }
    );
};

export const getComputedStatusVariable = (status) => {
    const normalizedStatus = String(status || "").trim().toUpperCase();

    return STAFF_COMPUTED_STATUSES.includes(normalizedStatus) ? normalizedStatus : undefined;
};

export const buildEventsWhere = ({
    constructionPeriod,
    exhibitionPeriod,
    dismantlingPeriod,
} = {}) => {
    const conditions = [];

    addPeriodOverlapConditions(
        conditions,
        constructionPeriod,
        "CONSTRUCTIONSTART_AT",
        "CONSTRUCTIONEND_AT"
    );
    addPeriodOverlapConditions(
        conditions,
        exhibitionPeriod,
        "START_AT",
        "END_AT"
    );
    addPeriodOverlapConditions(
        conditions,
        dismantlingPeriod,
        "DISMANTLING_START_AT",
        "DISMANTLING_END_AT"
    );

    return chainWhereConditions(conditions);
};

export const adaptEvent = (event = {}) => {
    const workerCount = Number(event.getWorkerUsersCount);
    const activeWorkerCount = Number(event.getWorkerSessionActiveCount);
    const subcontractors = (event.relWorkerSubcontractors || []).filter(Boolean);

    return {
        ...event,
        lifecycle_status: getComputedStatusVariable(event.getComputedStatus)?.toLowerCase() || "unknown",
        workers_count: workerCount > 0 ? workerCount : null,
        workers_on_site_count: activeWorkerCount > 0 ? activeWorkerCount : null,
        subcontractors,
        subcontractors_count: Number(event.getWorkerSubcontractorsCount) || 0,
    };
};
